<!-- <template>
  <div>
    <v-toolbar elevation="0" outlined dense>
      <v-btn small text> <v-icon left small>mdi-filter</v-icon> Locação </v-btn>
      <v-btn small text> <v-icon left small>mdi-filter</v-icon> Cliente </v-btn>
      <v-btn small text> <v-icon left small>mdi-filter</v-icon> Data </v-btn>
    </v-toolbar>
    <v-toolbar elevation="0" outlined dense>
      {{ selected.length }} selecionados
      <v-btn
        @click="
          cadastrarOrdemTransporte({
            tipo: 'E',
            produtos: selected.map(item => item.id)
          })
        "
        class="ml-2"
        small
        color="primary"
        :disabled="selected.length === 0"
        :loading="cadastrandoOrdem"
      >
        Entregar
      </v-btn>
      <v-btn
        @click="selected = []"
        small
        outlined
        class="ml-1"
        :disabled="selected.length === 0"
      >
        Cancelar
      </v-btn>
    </v-toolbar>
    <v-data-table
      v-if="ready"
      :headers="headers"
      :items="data"
      :loading="loading"
      show-select
      select-multiple
      v-model="selected"
    >
      <template v-slot:item.locacao_codigo="{ item }">
        <router-link
          :to="{
            name: 'locacoes_locacao_page',
            params: { codigo: item.locacao_codigo }
          }"
          v-text="item.locacao_codigo"
        ></router-link>
      </template>

      <template v-slot:item.qtd_entregue="{ item }">
        {{ item.qtd_entregue }}
        <v-icon
          v-text="item.status_entrega.icone"
          :title="item.status_entrega.status"
          right
          :color="item.status_entrega.cor"
        ></v-icon>
      </template>

      <template v-slot:item.qtd_recolhida="{ item }">
        {{ item.qtd_recolhida }}
        <v-icon
          v-text="item.status_recolhimento.icone"
          :title="item.status_recolhimento.status"
          right
          :color="item.status_recolhimento.cor"
        ></v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import QueryMixin from "@/mixins/QueryMixin";
import OrdensTransporteMixin from "@/mixins/locacoes/OrdensTransporteMixin";
import locacoes from "@/services/locacoes";

export default {
  mixins: [QueryMixin, OrdensTransporteMixin],

  components: {},

  props: {},

  data() {
    return {
      selected: [],
      headers: [
        {
          text: "Locação",
          value: "locacao_codigo"
        },
        {
          text: "Cliente",
          value: "cliente"
        },
        {
          text: "Produto",
          value: "produto"
        },
        {
          text: "Total",
          value: "qtd_solicitada",
          align: "right",
          width: 125
        },
        {
          text: "Entregue",
          value: "qtd_entregue",
          align: "right",
          width: 125
        },
        {
          text: "Recolhido",
          value: "qtd_recolhida",
          align: "right",
          width: 125
        },
        {
          text: "Prazo entrega",
          value: "data_entrega_formatada"
        },
        {
          text: "Prazo recolhimento",
          value: "data_entrega_formatada"
        }
      ]
    };
  },

  methods: {
    async getData() {
      return await locacoes.transportes.listarEntregas();
    },

    handleError(error) {
      alert("Não foi possível listar transportes");
    }
  },

  computed: {}
};
</script> -->

<template>
  <div>
    <PaginatedTable
      id="transportes_entregas"
      ref="table"
      v-model="selected"
      :headers="headers"
      :data-fetcher="locacoes.transportes.listarEntregas"
      show-select
      select-multiple
      hide-search
      hide-title
    >
      <template v-slot:top>
        <v-toolbar elevation="0" outlined dense>
          {{ selected.length }} selecionados
          <v-btn
            @click="
              cadastrarOrdemTransporte({
                tipo: 'E',
                produtos: selected.map(item => item.id)
              })
            "
            class="ml-2"
            small
            color="primary"
            :disabled="selected.length === 0"
            :loading="cadastrandoOrdem"
          >
            Entregar
          </v-btn>
          <v-btn
            @click="selected = []"
            small
            outlined
            class="ml-1"
            :disabled="selected.length === 0"
          >
            Cancelar
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:advancedFilters="{ advancedFilters, refresh, clear }">
        <v-chip-group>
          <v-chip @click="clear()">
            <v-icon small>mdi-filter-off</v-icon>
            Limpar
          </v-chip>

          <AdvancedFilterChip
            label="Locação"
            :active="!!advancedFilters.locacao"
          >
            <v-text-field
              v-model="advancedFilters.locacao"
              label="Número da locação"
              @keyup.enter="refresh()"
              @click:clear="refresh()"
              clearable
              autofocus
            ></v-text-field>
          </AdvancedFilterChip>
          <AdvancedFilterChip
            label="Cliente"
            :active="!!advancedFilters.cliente"
          >
            <v-text-field
              v-model="advancedFilters.cliente"
              label="Cliente"
              @keyup.enter="refresh()"
              @click:clear="refresh()"
              clearable
              autofocus
            ></v-text-field>
          </AdvancedFilterChip>
          <AdvancedFilterChip
            label="Situação"
            :active="
              advancedFilters.status && advancedFilters.status !== 'todos'
            "
          >
            <v-radio-group v-model="advancedFilters.status" @change="refresh()">
              <v-radio label="Todos" value="todos"></v-radio>
              <v-radio label="Dentro do prazo" value="em_dia"></v-radio>
              <v-radio label="Pendente entrega" value="em_atraso"></v-radio>
            </v-radio-group>
          </AdvancedFilterChip>
        </v-chip-group>
      </template>

      <template v-slot:item.locacao_codigo="{ item }">
        <router-link
          :to="{
            name: 'locacoes_locacao_page',
            params: { codigo: item.locacao_codigo }
          }"
          v-text="item.locacao_codigo"
        ></router-link>
      </template>

      <template v-slot:item.qtd_entregue="{ item }">
        {{ item.qtd_entregue }}
        <v-icon
          v-text="item.status_entrega.icone"
          :title="item.status_entrega.status"
          right
          :color="item.status_entrega.cor"
        ></v-icon>
      </template>

      <template v-slot:item.qtd_recolhida="{ item }">
        {{ item.qtd_recolhida }}
        <v-icon
          v-text="item.status_recolhimento.icone"
          :title="item.status_recolhimento.status"
          right
          :color="item.status_recolhimento.cor"
        ></v-icon>
      </template>
    </PaginatedTable>
  </div>
</template>

<script>
import locacoes from "@/services/locacoes";
import OrdensTransporteMixin from "@/mixins/locacoes/OrdensTransporteMixin";
import alertsMixin from "../../../mixins/alerts";
import AdvancedFilterChip from "@/components/server/advancedFilters/AdvancedFilterChip.vue";
import PaginatedTable from "@/components/server/PaginatedTable.vue";

export default {
  mixins: [OrdensTransporteMixin, alertsMixin],

  components: {
    AdvancedFilterChip,
    PaginatedTable
  },

  props: {},

  data() {
    return {
      locacoes,
      selected: [],
      realocando: false,
      headers: [
        {
          text: "Locação",
          value: "locacao_codigo"
        },
        {
          text: "Cliente",
          value: "cliente"
        },
        {
          text: "Produto",
          value: "produto"
        },
        {
          text: "Total",
          value: "qtd_solicitada",
          align: "right",
          width: 125
        },
        {
          text: "Entregue",
          value: "qtd_entregue",
          align: "right",
          width: 125
        },
        {
          text: "Recolhido",
          value: "qtd_recolhida",
          align: "right",
          width: 125
        },
        {
          text: "Prazo entrega",
          value: "data_entrega_formatada"
        },
        {
          text: "Prazo recolhimento",
          value: "data_recolhimento_formatada"
        }
      ]
    };
  },

  methods: {
    async getData() {
      return await locacoes.transportes.listarRecolhimentos(
        this.advancedFilters
      );
    },

    handleError(error) {
      alert("Não foi possível listar transportes");
    },

    async realocar() {
      this.realocando = true;
      try {
        const realocacao = await locacoes.locacoes.realocar({
          produtos: this.selected.map(item => ({
            locacao_produto_id: item.id
          }))
        });

        this.$router.push({
          name: "locacoes_locacao_page",
          params: {
            codigo: realocacao.codigo
          }
        });

        this.alert("Realocação cadastrada com sucesso");
      } catch (error) {
        console.error(error);

        if (error.response.data.message) {
          this.error(error.response.data.message);
          return;
        }

        this.error("Não foi possível realocar");
      } finally {
        this.realocando = false;
      }
    }
  },

  computed: {}
};
</script>
